export type BusinessType = 'cafeteria' | 'restaurante' | 'autolavado' | 'belleza' | 'gimnasio' | 'veterinaria' | 'tienda' | 'otro';

export const businessTypes: { id: BusinessType; label: string }[] = [
  { id: 'cafeteria', label: 'Cafetería' },
  { id: 'restaurante', label: 'Restaurante' },
  { id: 'autolavado', label: 'Autolavado' },
  { id: 'belleza', label: 'Salón de belleza' },
  { id: 'gimnasio', label: 'Gimnasio' },
  { id: 'veterinaria', label: 'Veterinaria' },
  { id: 'tienda', label: 'Tienda' },
  { id: 'otro', label: 'Otro' },
];

export type UserProfile = {
  id?: string;
  email?: string;
  groups: string[];
  ownerProfile?: { firstName: string; lastName: string; phone: string } | null;
};

export type Business = {
  id: string;
  name: string;
  slug: string;
  status: 'onboarding' | 'active' | 'paused';
  plan: 'local' | 'negocio' | 'red';
  ownerEmail: string;
  phone: string;
  businessType?: BusinessType;
  branches: number;
  location?: { address: string; latitude: number | null; longitude: number | null };
  pricing: { currency: 'MXN'; standardMonthlyAmount: number; billingCycle?: 'monthly' | 'annual'; monthlyAmount: number; periodAmount?: number; taxAmount?: number; chargedAmount?: number; isCustom: boolean; note: string };
  loyalty: { reward: string; visitsRequired: number; primaryColor: string; templateId?: 'clasica' | 'calida' | 'natural' | 'moderna' | 'elegante'; accentColor?: string; stampSecondaryColor?: string; stampBadgeColor?: string; stampBadgeEnabled?: boolean; textColor?: string; cardTitle?: string; programName?: string; rewardLabel?: string; logoDataUrl?: string; stampIcon?: string; stampImageDataUrl?: string; stampPackId?: string };
  billing: { requiresInvoice: boolean; legalName: string; rfc: string; taxRegime: string; cfdiUse: string; email: string; postalCode: string };
  wallet?: { issuer: string; apple: string; google: string };
  createdAt?: string;
  createdBy?: string;
  onboardingCompletedAt?: string;
};

export type BusinessInput = Omit<Business, 'id'>;

export const planPrices = { local: 200, negocio: 200, red: 200 } as const;

export const emptyBusiness: BusinessInput = {
  name: '', slug: '', status: 'onboarding', plan: 'local', ownerEmail: '', phone: '', branches: 1,
  location: { address: '', latitude: null, longitude: null },
  pricing: { currency: 'MXN', standardMonthlyAmount: 200, billingCycle: 'monthly', monthlyAmount: 200, periodAmount: 200, taxAmount: 32, chargedAmount: 232, isCustom: false, note: '' },
  loyalty: { reward: '', visitsRequired: 5, primaryColor: '#0E1226' },
  billing: { requiresInvoice: false, legalName: '', rfc: '', taxRegime: '', cfdiUse: '', email: '', postalCode: '' },
};
